export default "__VITE_ASSET__Bl32RZ0x__"